import { Injectable } from '@angular/core';
import { SystemService } from 'common/services/core-services/system.service';
import {
  GridData,
  GridModel,
  GridParams,
  GridPostParams,
} from 'common/models/utility-models/list-utility.model';
import { DataModel } from 'common/models/utility-models/base-model';
import { DataService } from './data.service';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL, OperationType } from 'common/constants/sm-constants';

@Injectable()
export abstract class GridDataService<
  T extends GridModel<D>,
  D extends DataModel
> extends DataService<T> {
  protected constructor(
    protected apiUrl: API_URL,
    apiService: SmApiService,
    protected ss: SystemService
  ) {
    super(ss, apiUrl, apiService);
  }

  transformDataModel(apiRes, param: string) {
    let data = !apiRes[param] ? [] : apiRes[param];
    if (data.length > 0) {
      data = apiRes[param]?.sort((a, b) => b.id - a.id);
    }
    return apiRes;
  }
  abstract getGridParams(params): GridPostParams;
  abstract override getDeleteUrl(): string;

  async preinitData(result: any): Promise<any> {
    return await new Promise<any>((resolve, reject) => {
      resolve(result);
    });
  }

  override getCustomDeleteUrl() {
    return this.getDeleteUrl();
  }

  async postDatatoGrid(
    initUrl: string = '',
    queryParams: GridParams = null
  ): Promise<T[]> {
    return await new Promise<T[]>((resolve, reject) => {
      let url;

      url = initUrl !== '' ? initUrl : this.getCustomUrl(OperationType.VIEW);

      const data = this.modifyGridPostParams(queryParams);

      // const formData = this.convertFormData(data);
      const formData = data;

      this.apiService
        .postData(url, formData)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  modifyGridPostParams(queryParams) {
    return this.getGridParams(queryParams);
  }

  async fetchData(queryParams = null, params = null): Promise<any[]> {
    return await new Promise<any>((resolve, reject) => {
      this.postDatatoGrid('', queryParams)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => reject(error));
    });
  }

  protected cloneData(data): any {
    return JSON.parse(JSON.stringify(data));
  }

  // GridWidgetModel

  async createGridModel(
    apiRes: any,
    queryParam: GridParams,
    dataParam: string = 'details',
    extraParam: string = ''
  ): Promise<any> {
    return await new Promise<any>((resolve, reject) => {
      const gridModel = new GridModel<T>();
      const gridData = this.transformDataModel(apiRes, dataParam);
      gridModel.originalModel = !gridData[dataParam] ? [] : gridData[dataParam];
      gridModel.filterModel = this.cloneData(gridModel.originalModel);

      let dataExtra;
      dataExtra = !apiRes[extraParam] ? [] : apiRes[extraParam];
      
      if (dataExtra.length > 0) {
        dataExtra = apiRes[extraParam]?.sort((a, b) => b.id - a.id);
      }

      if (extraParam) {
        gridModel.extraData = dataExtra;
      }
      
      gridModel.pageModel = gridModel.originalModel;
      gridModel.pages = [];
      gridModel.search_text = '';
      gridModel.selectedPage = queryParam.currentPage
        ? queryParam.currentPage
        : 1;
      // gridModel.recordPerPage = queryParam.recordPerPage
      //   ? queryParam.recordPerPage
      //   : 7;      
      gridModel.recordPerPage = 10;
      gridModel.totalRecords = gridModel.originalModel?.length;
      const pageData = this.getPageData(
        this.cloneData(gridModel.filterModel),
        queryParam.recordPerPage,
        gridModel.totalRecords,
        queryParam.currentPage
      );
      gridModel.pageModel = pageData.pageModel;
      gridModel.pages = pageData.pages;
      gridModel.chartsData = this.prepareChartsData(gridModel.originalModel);
      const modifiedGridModel = this.getModifiedGridModel(apiRes, gridModel);
      resolve(modifiedGridModel);
    }).catch((error) => {
      // return error;
      
      const gridModel = new GridModel<T>();
      gridModel.extraData = queryParam;
            gridModel.originalModel = [];
            gridModel.filterModel = [];
            gridModel.pageModel = [];
            gridModel.pages = [];
          return  gridModel;
    });
  }

  getModifiedGridModel(apiRes, gridModel) {
    return gridModel;
  }

  prepareChartsData(apiData) {
    return {};
  }

  async getGridData(queryParam: GridParams, params = null): Promise<T> {
  //  console.log(queryParam);
    
    return await new Promise<T>((resolve, reject) => {
      this.fetchData(queryParam, params)
        .then((apiRes) => {
          const result: any = this.modifyResponse(apiRes);
          this.preinitData(result)
            .then((res) => {
              this.createGridModel(
                result,
                queryParam,
                this.getDataParam(),
                this.getExtraParam()
              )
                .then((gridData) => {
                  resolve(gridData);
                })
                .catch((e) => {
                  reject(e);
                });
            })
            .catch((e) => reject(e));
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  getDataParam() {
    return 'details';
  }

  getExtraParam() {
    return '';
  }

  modifyResponse(apiRes) {
    return apiRes;
  }

  // filterData(originalModel, filterModel, searchValue, searchableFields, pageModel): T[] {
  //     filterModel = originalModel;
  //     filterModel = originalModel.filter(row => {
  //         return searchableFields.some(column => {
  //             const cellValue = String(row[column]).toLowerCase();
  //             return cellValue.includes(searchValue.toLowerCase());
  //         });
  //     });
  //     pageModel = filterModel;
  //     return filterModel;
  // }

  // filterData(originalModel, filterModel, searchValue, searchableFields, pageModel) {
  //     // If searchValue is a string, perform the original filtering logic
  //     if (typeof searchValue === 'string') {
  //         filterModel = originalModel.filter(row => {
  //             return searchableFields.some(column => {
  //                 const cellValue = String(row[column]).toLowerCase();
  //                 return cellValue.includes(searchValue.toLowerCase());
  //             });
  //         });

  //     } else if (typeof searchValue === 'object' && searchValue !== null) {

  //         filterModel = originalModel.filter(row => {
  //             return Object.keys(searchValue).every(key => {
  //                 return searchableFields.some(column => {
  //                     const cellValue = String(row[column]).toLowerCase();
  //                     return cellValue.includes(searchValue[key].toLowerCase());
  //                 });

  //             });
  //         });

  //     }
  //     pageModel = filterModel;
  //     return filterModel;
  // }

  filterData(
    originalModel,
    filterModel,
    searchValue,
    searchableFields,
    pageModel,
    isMultipleFilter: boolean = false
  ) {
    // If searchValue is a string, perform the original filtering logic
    if (typeof searchValue === 'string') {
      filterModel = originalModel.filter((row) => {
        return searchableFields.some((column) => {
          const cellValue = String(row[column]).toLowerCase();
          return cellValue.includes(searchValue.toLowerCase());
        });
      });
    } else if (typeof searchValue === 'object' && searchValue !== null) {
      if (isMultipleFilter) {
        filterModel = originalModel.filter((row) => {
          return Object.keys(searchValue).every((key) => {
            const cellValue = String(row[key]).toLowerCase();
            return cellValue.includes(searchValue[key].toLowerCase());
          });
        });
      } else {
        filterModel = originalModel.filter((row) => {
          return Object.keys(searchValue).every((key) => {
            return searchableFields.some((column) => {
              const cellValue = String(row[column]).toLowerCase();
              return cellValue.includes(String(searchValue[key]).toLowerCase());
            });
          });
        });
      }
    }
    // console.log(filterModel);
    pageModel = filterModel;
    return filterModel;
  }

  getPageData(
    originalModel,
    recordPerPage,
    totalRecords,
    pageNumber
  ): GridData<T> {
    const pageData = new GridData<T>();
    const numberOfPage = Math.ceil(originalModel.length / recordPerPage);
    const data = originalModel.slice(
      (pageNumber - 1) * recordPerPage,
      recordPerPage * pageNumber
    );
    pageData.pageModel = data;
    pageData.pages = Array.from({ length: numberOfPage }, (_, idx) => ++idx);
    return pageData;
  }

  processGridData(originalModel, queryParam: GridParams): any {
    return new Promise<any>((resolve, reject) => {
      this.createGridModel({ detail: originalModel }, queryParam)
        .then((gridData) => {
          resolve(gridData);
        })
        .catch((e) => reject(e));
    });
  }

  initGridActions(event) {
    const actions = event.actionData;
    const data = event.editDetail;
    this.postActionData(actions, data);
  }

  createQueryParams(): GridParams {
    return new GridParams();
  }

  downloadGridSampleExcel(): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.getExcelUploadUrl();
      this.apiService.getImage(url).then((data) => {
        resolve(data);
      });

      //         const base64Data = data.base64Data;

      // // Content type for Excel files
      // const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

      // // Convert base64 data to Blob
      // const blob = base64ToBlob(base64Data, contentType);

      // // Create a temporary download link and trigger the download
      // const downloadLink = document.createElement('a');
      // downloadLink.href = URL.createObjectURL(blob);
      // downloadLink.download = 'sample.xlsx'; // Specify the file name
      // document.body.appendChild(downloadLink);
      // downloadLink.click();
      // document.body.removeChild(downloadLink);
    });
  }

  downloadToBlob(apiUrl, payload): Promise<any> {
    return new Promise((resolve, reject) => {
      this.apiService.getFile(apiUrl, payload).then((data) => {
        resolve(data);
      });
    });
  }

  base64ToBlob(base64, contentType) {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }

  getExcelUploadUrl() {
    return '';
  }

  postActionData(act, data) {}
}
